import axios, { AxiosPromise } from "axios";
import { dashboardApiConfig, ops } from "./config";
import { MenuChatEffort, MenuChatMessage } from "../state/atoms";

export interface MenuChatResponseDto {
  messages: MenuChatMessage[];
  omittedDesigns: string[];
}

const base = () => `${dashboardApiConfig.basePath}/menu-chat`;

const MenuChatApi = {
  getMessages(locationId: number): AxiosPromise<MenuChatResponseDto> {
    return axios.get(`${base()}/messages`, { ...ops(), params: { locationId } });
  },

  sendMessage(locationId: number, content: string, effort: MenuChatEffort): AxiosPromise<MenuChatResponseDto> {
    return axios.post(`${base()}/messages`, { locationId, content, effort }, ops());
  },

  clearMessages(locationId: number): AxiosPromise<void> {
    return axios.delete(`${base()}/messages`, { ...ops(), params: { locationId } });
  },

  applyChanges(locationId: number, messageId: number): AxiosPromise<MenuChatMessage> {
    return axios.post(`${base()}/changes/apply`, { locationId, messageId }, ops());
  },

  dismissChanges(locationId: number, messageId: number): AxiosPromise<MenuChatMessage> {
    return axios.post(`${base()}/changes/dismiss`, { locationId, messageId }, ops());
  },
};

export default MenuChatApi;
